import { Button } from "primereact/button";
import { genElDate } from "../../../../components/utils/EditorDialogElementGenerator";
import {
  endOfDay,
  endOfMonth,
  endOfWeek,
  endOfYear,
  format,
  startOfDay,
  startOfMonth,
  startOfWeek,
  startOfYear,
} from "date-fns";
import useIsMobile from "../../../../hooks/useIsMobile";
import React, { useState } from "react";

const OwnerDashboardGlobalFilter = (props) => {
  const { setFilterValue, filterValue, error, loading } = props;

  const isMobile = useIsMobile();
  const [date, setDate] = useState({
    dari_tanggal: format(startOfMonth(new Date()), "yyyy-MM-dd HH:mm:ss"),
    sampai_tanggal: format(endOfMonth(new Date()), "yyyy-MM-dd HH:mm:ss"),
  });

  const elStartDate = genElDate({
    name: "Start Date",
    field: "dari_tanggal",
    max: new Date(),
    data: date,
    setData: setDate,
    error,
    disabled: loading,
    disableKeyboard: true,
    showIcon: false,
    customLabelCSS: "text-sm text-black font-medium",
  });

  const elEndDate = genElDate({
    name: "End Date",
    field: "sampai_tanggal",
    data: date,
    setData: setDate,
    error,
    disabled: loading,
    disableKeyboard: true,
    showIcon: false,
    customLabelCSS: "text-sm text-black font-medium",
  });

  const formatDateTime = (date) => format(date, "yyyy-MM-dd HH:mm:ss");

  const capToToday = (endDate) => {
    const todayEnd = endOfDay(new Date());
    return endDate > todayEnd ? todayEnd : endDate;
  };

  const filterTimeBlock = [
    {
      label: "Today",
      mobile_label: "1D",
      dari_tanggal: formatDateTime(startOfDay(new Date())),
      sampai_tanggal: formatDateTime(endOfDay(new Date())),
    },
    {
      label: "This Week",
      mobile_label: "7D",
      dari_tanggal: formatDateTime(
        startOfWeek(new Date(), { weekStartsOn: 1 })
      ),
      sampai_tanggal: formatDateTime(
        endOfWeek(new Date(), { weekStartsOn: 1 })
      ),
    },
    {
      label: "This Month",
      mobile_label: "1M",
      dari_tanggal: formatDateTime(startOfMonth(new Date())),
      sampai_tanggal: formatDateTime(endOfMonth(new Date())),
    },
    {
      label: "This Year",
      mobile_label: "1Y",
      dari_tanggal: formatDateTime(startOfYear(new Date())),
      sampai_tanggal: formatDateTime(endOfYear(new Date())),
    },
    {
      label: "Lifetime",
      mobile_label: "Lifetime",
      dari_tanggal: "2017-12-01 00:00:00",
      sampai_tanggal: formatDateTime(capToToday(endOfDay(new Date()))),
    },
  ];

  return (
    <div className="w-full p-2 col-center-start gap-3 elevated-card-tight-vertical !rounded-lg !shadow-md border border-gray-300">
      <div className="flex justify-between items-center w-full">
        {/* Label */}
        <label className="flex items-center gap-2 text-lg font-semibold">
          <i className="pi pi-filter bg-gradient-to-br bg-clip-text text-transparent from-green-400 to-emerald-500"></i>
          Filter Period
        </label>
        {/*<ToggleThemeButton
          activeTheme={activeTheme}
          toggleTheme={toggleTheme}
        />*/}
      </div>

      <div className="col-center-start gap-2 w-full">
        <label className="row-start-center text-sm text-black font-medium">
          <i className="pi pi-clock bg-gradient-to-br bg-clip-text text-transparent from-green-400 to-emerald-500 mr-2" />
          Quick Filter
        </label>
        <div className="row-start-center gap-2 w-full">
          {filterTimeBlock.map((el) => (
            <Button
              key={el.label}
              onClick={() => {
                setFilterValue({
                  ...filterValue,
                  dari_tanggal: el.dari_tanggal,
                  sampai_tanggal: el.sampai_tanggal,
                });
                setDate({
                  dari_tanggal: el.dari_tanggal,
                  sampai_tanggal: el.sampai_tanggal,
                });
              }}
              className={`row-center-center rounded-xl text-xs sm:text-sm font-medium capitalize transition-all ${
                filterValue.dari_tanggal === el.dari_tanggal &&
                filterValue.sampai_tanggal === el.sampai_tanggal
                  ? "text-white !font-semibold shadow-md border-none bg-gradient-to-br from-green-400 to-emerald-500"
                  : "bg-gray-100 text-black hover:bg-gray-200 border-none"
              }`}
              disabled={loading}
            >
              {isMobile ? el.mobile_label : el.label}
            </Button>
          ))}
        </div>
      </div>
      <div className="row-center-center gap-2 w-full font-medium">
        {elStartDate} {elEndDate}
      </div>
      <div className="w-full row-end-center gap-2 mt-2">
        <Button
          icon="pi pi-refresh"
          label="Load Report"
          loading={loading}
          className="w-full sm:w-auto sm:max-h-[3rem] rounded-md bg-gradient-to-br from-green-400 to-emerald-500 text-white font-semibold shadow-md hover:shadow-lg border-none"
          onClick={() => {
            setFilterValue({
              ...filterValue,
              dari_tanggal: date.dari_tanggal,
              sampai_tanggal: date.sampai_tanggal,
            });
          }}
        />
      </div>

      <span className="w-full row-start-center text-red-500 text-sm">
        {error.tanggal}
      </span>
    </div>
  );
};

export default React.memo(OwnerDashboardGlobalFilter);
